import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTiles = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.24996 1.09901e-10H5.33996C5.93843 -5.91077e-06 6.51225 0.238419 6.9345 0.662541C7.35674 1.08666 7.59262 1.66153 7.58996 2.26V5.34C7.58996 6.58264 6.5826 7.59 5.33996 7.59H2.24996C1.00732 7.59 -3.87813e-05 6.58264 -3.87813e-05 5.34V2.26C-0.00269866 1.66153 0.233179 1.08666 0.655425 0.662541C1.07767 0.238419 1.65149 -5.91077e-06 2.24996 1.09901e-10ZM5.33996 6.08C5.75192 6.07461 6.08458 5.74196 6.08996 5.33V2.26C6.08996 1.84579 5.75417 1.51 5.33996 1.51H2.24996C1.83575 1.51 1.49996 1.84579 1.49996 2.26V5.33C1.50535 5.74196 1.838 6.07461 2.24996 6.08H5.33996Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.66 1.09901e-10H15.75C16.3484 -5.91077e-06 16.9223 0.238419 17.3445 0.662541C17.7668 1.08666 18.0026 1.66153 18 2.26V5.34C18 6.58264 16.9926 7.59 15.75 7.59H12.66C11.4173 7.59 10.41 6.58264 10.41 5.34V2.25C10.41 1.00736 11.4173 1.09901e-10 12.66 1.09901e-10ZM15.75 6.08C16.1619 6.07461 16.4946 5.74196 16.5 5.33V2.26C16.5 1.84579 16.1642 1.51 15.75 1.51H12.66C12.2458 1.51 11.91 1.84579 11.91 2.26V5.33C11.9154 5.74196 12.248 6.07461 12.66 6.08H15.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.24996 10.41H5.33996C6.5826 10.41 7.58996 11.4173 7.58996 12.66V15.75C7.58996 16.9926 6.5826 18 5.33996 18H2.24996C1.65149 18 1.07767 17.7616 0.655425 17.3374C0.233179 16.9133 -0.00269866 16.3384 -3.87813e-05 15.74V12.66C-3.87813e-05 11.4173 1.00732 10.41 2.24996 10.41ZM5.33996 16.49C5.75417 16.49 6.08996 16.1542 6.08996 15.74V12.66C6.08458 12.248 5.75192 11.9154 5.33996 11.91H2.24996C1.838 11.9154 1.50535 12.248 1.49996 12.66V15.74C1.49996 16.1542 1.83575 16.49 2.24996 16.49H5.33996Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.66 10.41H15.75C16.9926 10.41 18 11.4173 18 12.66V15.74C18.0027 16.3384 17.7668 16.9133 17.3445 17.3374C16.9223 17.7616 16.3485 18 15.75 18H12.66C12.0615 18 11.4877 17.7616 11.0655 17.3374C10.6432 16.9133 10.4073 16.3384 10.41 15.74V12.66C10.41 11.4173 11.4174 10.41 12.66 10.41ZM15.75 16.49C16.1642 16.49 16.5 16.1542 16.5 15.74V12.66C16.4946 12.248 16.162 11.9154 15.75 11.91H12.66C12.248 11.9154 11.9154 12.248 11.91 12.66V15.74C11.91 16.1542 12.2458 16.49 12.66 16.49H15.75Z",
			fill: "currentColor"
		})
	]
});
export default SvgTiles;
